import LoginEditor from './LoginEditor';

export default LoginEditor;
